import React from 'react';
import { Box, Divider, Flex } from '@podiumhq/design-system';

import {
  PACKAGES,
  LIMITS_FEATURE_LIST,
  BASIC_COMMUNICATION_FEATURE_LIST,
  ADVANCED_COMMUNICATION_FEATURE_LIST,
  PAYMENTS_FEATURE_LIST,
  MARKETING_FEATURE_LIST,
  SUPPORT_ONBOARDING_FEATURE_LIST,
} from '../constants';
import { baseHeadingStyles, columnStyles } from '../styles';

import RowWithHeaderPriceCta from './RowWithHeaderPriceCta';
import BundleFeatureTitle from './BundleFeatureTitle';
import BundleFeatureListItem from './BundleFeatureListItem';

const BundleList = () => (
  <Box boxSizing="border-box" width="100%">
    <RowWithHeaderPriceCta mt="28px" />

    <BundleFeatureSection
      key="Limits"
      displayBottomDivider={false}
      displayFeatureItemDivider={true}
      featureList={LIMITS_FEATURE_LIST}
      sectionTitle="Limits"
    />
    <BundleFeatureSection
      key="Basic Communication"
      featureList={BASIC_COMMUNICATION_FEATURE_LIST}
      mt="28px"
      sectionTitle="Basic Communication"
    />
    <BundleFeatureSection
      key="Advanced Communication"
      featureList={ADVANCED_COMMUNICATION_FEATURE_LIST}
      sectionTitle="Advanced Communication"
    />
    <BundleFeatureSection
      key="Payments"
      featureList={PAYMENTS_FEATURE_LIST}
      sectionTitle="Payments"
    />
    <BundleFeatureSection
      key="Marketing"
      featureList={MARKETING_FEATURE_LIST}
      sectionTitle="Marketing"
    />
    <BundleFeatureSection
      key="Support and Onboarding"
      featureList={SUPPORT_ONBOARDING_FEATURE_LIST}
      sectionTitle="Support and Onboarding"
    />
  </Box>
);

const BundleFeatureSection = ({
  bundleName,
  displayBottomDivider = true,
  displayFeatureItemDivider = false,
  featureList = [],
  sectionTitle,
  ...props
}) => (
  <Box padding="16px" {...props}>
    <BundleFeatureTitle
      title={sectionTitle}
      titleStyles={baseHeadingStyles}
      tooltipTitleStyles={baseHeadingStyles}
    />

    {featureList.map((feature = {}, index) => (
      <FeatureListRow
        key={`feature-${index}-${feature.title}`}
        displayDivider={displayFeatureItemDivider}
        feature={feature}
      />
    ))}

    {displayBottomDivider && <Divider my={6} />}
  </Box>
);

const FeatureListRow = ({ displayDivider, feature = {}, ...props }) => (
  <>
    <Flex mt={6} width="100%" {...props}>
      <Flex justify="flex-start" {...listColumnStyles}>
        <BundleFeatureTitle
          hoverLabel={feature.hoverText}
          title={feature.title}
        />
      </Flex>

      <BundleFeatureListItem
        key={PACKAGES.ESSENTIALS}
        featureItem={feature[PACKAGES.ESSENTIALS]}
        featureItemHoverLabel={feature.secondHoverText}
        width="25%"
      />

      <BundleFeatureListItem
        key={PACKAGES.STANDARD}
        featureItem={feature[PACKAGES.STANDARD]}
        featureItemHoverLabel={feature.thirdHoverText}
        width="25%"
      />

      <BundleFeatureListItem
        key={PACKAGES.PROFESSIONAL}
        featureItem={feature[PACKAGES.PROFESSIONAL]}
        featureItemHoverLabel={feature.fourthHoverText}
        width="25%"
      />
    </Flex>

    {displayDivider && <Divider mt={6} />}
  </>
);

const listColumnStyles = {
  ...columnStyles,
  width: '25%',
};

export default BundleList;
